import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import axios from 'axios';

const SettlementReport = ({
  id,
  handleToast,
  closeLoading,
  handleLoading,
}) => {

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [filters, setFilters] = useState({
    roomId: "",
    guestName: "",
    checkoutStatus: "All",
  });
const [dateRangeOption, setDateRangeOption] = useState('1 Week');

  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [totals, setTotals] = useState({
    cash: 0,
    upi: 0,
    creditCard: 0,
    debitCard: 0,
  });


  const calculateStartDate = (option) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0); // set to start of day

  switch (option) {
    case '1 Week':
      return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    case '15 Days':
      return new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000);
    case '1 Month':
      // approx 1 month = 30 days
      return new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
    case 'Custom Date':
    default:
      return startDate; // keep current if custom
  }
};

const formatDate = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const year = d.getFullYear();
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

  // Fetch reports function
const fetchReports = async (start = startDate, end = endDate) => {
  handleLoading();

  try {
    const response = await axios.post(
      `https://api.dectwinhotel.com/api/${id}_bookings/reports`,
      {
        startDate: formatDate(start),
        endDate: formatDate(end),
      }
    );
    closeLoading();
    handleToast({
      toastMsg: "Reports Fetched Successfully!!!",
      toastColor: "#4CAF50",
    });

    const sortedData = response.data.sort((a, b) => Number(a.inv_no) - Number(b.inv_no));
    setReports(sortedData);
    setFilteredReports(sortedData);
  } catch (err) {
    if (err.code === "ECONNABORTED") {
      fetchReports(start, end);
    }
    handleToast({
      toastMsg: "Something went wrong! Please try again",
      toastColor: "#FF0000",
    });
    closeLoading();
  }
};


useEffect(() => {
  if (dateRangeOption !== 'Custom Date') {
    const newStartDate = calculateStartDate(dateRangeOption);
    const newEndDate = new Date();
    newEndDate.setHours(0, 0, 0, 0);
    setStartDate(newStartDate);
    setEndDate(newEndDate);

    fetchReports(newStartDate, newEndDate); // <-- pass the updated dates
  }
}, [dateRangeOption]);

useEffect(() => {
  if (dateRangeOption === 'Custom Date') {
    fetchReports(startDate, endDate);
  }
}, [startDate, endDate, dateRangeOption]);


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };


  const getBasePaymentMethod = (paymentMethod) => {
    if (typeof paymentMethod !== 'string') return '';
    return paymentMethod.includes('|') ? paymentMethod.split('|')[0].trim() : paymentMethod.trim();
  };


  const getPaymentAmount = (paymentMethod, method) => {
    if (typeof paymentMethod !== 'string') return null;
    if (!paymentMethod.includes('|')) return null;

    const parts = paymentMethod.split('|').map(p => p.trim());

    for (const part of parts) {
      if (part.toLowerCase().startsWith(method.toLowerCase())) {
        const amt = part.split('-')[1];
        if (amt) return parseFloat(amt).toFixed(2);
      }
    }
    return null;
  };


  useEffect(() => {
    const roomIdFilter = filters.roomId.trim();

    const filtered = reports.filter(report => {
      if (roomIdFilter && report.room_no.toString().trim() !== roomIdFilter) {
        return false;
      }

      const checkoutDate = new Date(report.to_date);
      checkoutDate.setHours(0, 0, 0, 0);

      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);

      return checkoutDate >= start && checkoutDate <= end;
    });

    setFilteredReports(filtered);
  }, [filters.roomId, reports, startDate, endDate]);



  const calculateTotals = (reports) => {
    let cash = 0, upi = 0, creditCard = 0, debitCard = 0;

    reports.forEach(report => {
      const baseMethod = getBasePaymentMethod(report.payment_method);
      const amount = parseFloat(report.total_amount) + parseFloat(report.tax_amount);

      if (baseMethod === 'Multiple Method') {
        cash += parseFloat(getPaymentAmount(report.payment_method, 'Cash')) || 0;
        upi += parseFloat(getPaymentAmount(report.payment_method, 'UPI')) || 0;
        creditCard += parseFloat(getPaymentAmount(report.payment_method, 'Credit Card')) || 0;
        debitCard += parseFloat(getPaymentAmount(report.payment_method, 'Debit Card')) || 0;
      } else if (baseMethod === 'Cash' || baseMethod == null) {
        cash += amount;
      } else if (baseMethod === 'Unified Payment Interface (UPI)') {
        upi += amount;
      } else if (baseMethod === 'Credit Card') {
        creditCard += amount;
      } else if (baseMethod === 'Debit Card') {
        debitCard += amount;
      }
    });

    setTotals({
      cash: cash.toFixed(2),
      upi: upi.toFixed(2),
      creditCard: creditCard.toFixed(2),
      debitCard: debitCard.toFixed(2),
    });
  };


  useEffect(() => {
    calculateTotals(filteredReports);
  }, [filteredReports]);


  return (
    <>
      <section
        style={{
          backgroundColor: "#282c34",
          padding: "4rem 1rem",
        }}
      >
        <div className="reports-page">
          <h2>Settlement Report</h2>

          <div className="row my-3">
<div className="col-lg-4 col-12 my-2">
  <label>Select Date Range:</label>
  <select
    className="form-select"
    value={dateRangeOption}
    onChange={(e) => setDateRangeOption(e.target.value)}
  >
    <option value="1 Week">1 Week</option>
    <option value="15 Days">15 Days</option>
    <option value="1 Month">1 Month</option>
    <option value="Custom Date">Custom Date</option>
  </select>

  {dateRangeOption === 'Custom Date' && (
    <div className="date-picker mt-2">
<DatePicker
  selected={startDate}
  onChange={(date) => setStartDate(date)}
  maxDate={new Date()}
/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<DatePicker
  selected={endDate}
  onChange={(date) => setEndDate(date)}
  maxDate={new Date()}
/>
    </div>
  )}
</div>


            <div className="col-lg-2 col-12 my-2">
              <label>Room Number:</label>
              <input
                type="text"
                name="roomId"
                value={filters.roomId}
                onChange={handleFilterChange}
                placeholder="Enter room number"
              />
            </div>

            {/* <div className="col-lg-2 col-12 my-2 pt-4 text-end">
<button
  className="fetch-btn mt-2"
  onClick={() => fetchReports(startDate, endDate)}
>
  Fetch Reports
</button>
            </div> */}
          </div>

          <div className='row mb-3'>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='text-center py-3 align-content-center text-light fw-semibold rounded-4 bg-success'>
<i class="fa-solid fa-money-bills fs-3"></i>
                <p>Cash</p>₹{totals.cash}</div>
            </div>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='text-center py-3 align-content-center text-light fw-semibold rounded-4 bg-warning'>
<i class="fa-solid fa-qrcode fs-3"></i>                <p>UPI</p>₹{totals.upi}</div>
            </div>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='text-center py-3 align-content-center text-light fw-semibold rounded-4 bg-info'>
<i class="fa-solid fa-credit-card fs-3"></i>
                <p>Credit Card</p>₹{totals.creditCard}</div>
            </div>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='text-center py-3 align-content-center text-light fw-semibold rounded-4 bg-danger'>
<i class="fa-solid fa-credit-card fs-3"></i>                <p>Debit Card</p>₹{totals.debitCard}</div>
            </div>

          </div>
          {/* row ends */}

          {reports.length > 0 && (
            <div className="table-responsive">
              <table className="reports-table">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Check-in Date</th>
                    <th>Room No</th>
                    <th>Check-out Date</th>
                    <th>Payment Method</th>
                    <th colSpan={4}>Breakdown</th>
                    <th>Amount</th>
                  </tr>

                  <tr>
                    <th colSpan={5}></th>
                    <th>Cash</th>
                    <th>UPI</th>
                    <th>Credit Card</th>
                    <th>Debit Card</th>
                    <th>₹</th>
                  </tr>

                </thead>
                <tbody>
                  {filteredReports.map((report) => {
                    const baseMethod = getBasePaymentMethod(report.payment_method);
                    return (
                      <tr key={report.inv_no}>
                        {/* Fill with your table data */}
                        <td>{report.inv_no}</td>
                        <td>{new Date(report.from_date).toLocaleString()}</td>
                        <td>{report.room_no}</td>
                        <td>{new Date(report.to_date).toLocaleString()}</td>
                        <td>
                          {baseMethod}
                        </td>
                        <td>
                          {/* Cash column */}
                          {baseMethod === 'Multiple Method'
                            ? getPaymentAmount(report.payment_method, 'Cash') || '0.00'
                            : (baseMethod === 'Cash' || baseMethod == null)
                              ? (parseFloat(report.total_amount) + parseFloat(report.tax_amount)).toFixed(2)
                              : null
                          }
                        </td>

                        <td>
                          {/* UPI column */}
                          {baseMethod === 'Multiple Method'
                            ? getPaymentAmount(report.payment_method, 'UPI') || '0.00'
                            : baseMethod === 'Unified Payment Interface (UPI)'
                              ? (parseFloat(report.total_amount) + parseFloat(report.tax_amount)).toFixed(2)
                              : null
                          }
                        </td>

                        <td>
                          {/* Credit Card column */}
                          {baseMethod === 'Multiple Method'
                            ? getPaymentAmount(report.payment_method, 'Credit Card') || '0.00'
                            : baseMethod === 'Credit Card'
                              ? (parseFloat(report.total_amount) + parseFloat(report.tax_amount)).toFixed(2)
                              : null
                          }
                        </td>

                        <td>
                          {/* Debit Card column */}
                          {baseMethod === 'Multiple Method'
                            ? getPaymentAmount(report.payment_method, 'Debit Card') || '0.00'
                            : baseMethod === 'Debit Card'
                              ? (parseFloat(report.total_amount) + parseFloat(report.tax_amount)).toFixed(2)
                              : null
                          }
                        </td>
                        <td>{(
                          parseFloat(report.total_amount) +
                          parseFloat(report.tax_amount)
                        ).toFixed(2)}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SettlementReport;
